import { render, staticRenderFns } from "./inteTable.vue?vue&type=template&id=37d7a156&scoped=true&"
import script from "./inteTable.vue?vue&type=script&lang=js&"
export * from "./inteTable.vue?vue&type=script&lang=js&"
import style0 from "./inteTable.vue?vue&type=style&index=0&id=37d7a156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7a156",
  null
  
)

export default component.exports